import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clear: {
		id: 'polaris.search-input.clear',
		defaultMessage: 'Clear',
		description: 'Label for the clear icon button.',
	},
});
